import React from 'react';
import { Menu, Icon, Badge, Row, Col } from 'antd';
import { useGlobalState } from '../state';


function ChannelsMenu() {
  const [messagesByChannel,] = useGlobalState('messagesByChannel');
  const channels = Object.keys(messagesByChannel || {});
  const [currentChannel, setCurrentChannel] = useGlobalState('currentChannel');
  const [unreadCountByChannel,] = useGlobalState('unreadCountByChannel');
  return (
    <Menu
      mode="inline"
      theme="dark"
      style={{ height: '100%', borderRight: 0 }}
      onSelect={({ key }) => { setCurrentChannel(key) }}
      selectedKeys={[currentChannel]}
    >
      {channels.map(channel =>
        <Menu.Item key={channel}>
          <Row type="flex" justify="space-between">
            <Col className="ellipsis">
              {channel === 'main' && <Icon type="home" />}
              {channel}
            </Col>
            <Col>
              <Badge count={unreadCountByChannel[channel]} overflowCount={99} />
            </Col>
          </Row>
        </Menu.Item>
      )}
    </Menu>
  );
}

export default ChannelsMenu;
